import { z } from 'zod'
import { errorDataSchema, eventDataSchema } from '../../common.schema'

export const AccountDelinkErrorSchema = z.object({
  event: z.literal('account_delink_error'),

  event_data: eventDataSchema,
  error_data: errorDataSchema,
})

export type AccountDelinkErrorEvent = z.infer<typeof AccountDelinkErrorSchema>
